function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoProfileTemplate = require('./saito-profile.template');
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var SaitoProfile = /*#__PURE__*/function () {
  function SaitoProfile(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SaitoProfile);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.tab_container;
    this.publicKey = null; //Always set externally...

    app.connection.on('profile-update-dom', function (publicKey, data) {
      if (!publicKey || !data) {
        return;
      }
      var banner = data.banner,
        description = data.description,
        image = data.image;
      if (banner) {
        var qs = ".profile-banner-".concat(publicKey);
        Array.from(document.querySelectorAll(qs)).forEach(function (element) {
          element.style.backgroundImage = "url('".concat(banner, "')");
        });
      }
      var container = document.querySelector('.saito-profile-description');
      if (container) {
        container.innerHTML = '';
        if (!description) {
          container.classList.add('empty');
          container.innerHTML = "\n            <div class=\"saito-description-edit\">\n              Add description\n            </div>\n          ";
        } else {
          container.classList.remove('empty');
          var sanitized = _this.app.browser.sanitize(description, true).replaceAll('\n', '<br>');
          container.innerHTML = "\n            <div\n              id=\"profile-description-".concat(publicKey, "\"\n              class=\"profile-description-").concat(publicKey, "\"\n              data-id=\"").concat(publicKey, "\"\n            >\n              ").concat(sanitized, "\n            </div>\n            <div class=\"saito-description-edit\">\n              <i class=\"fas fa-pen\"></i>\n            </div>\n          ");
        }
      }

      //
      // Slight hack to plug banner image into blog posts since we aren't using this yet...
      //
      var userImage = image || banner || null;
      if (userImage) {
        var _qs = ".profile-image-".concat(publicKey);
        Array.from(document.querySelectorAll(_qs)).forEach(function (element) {
          element.src = userImage;
        });
      }
    });
  }
  return _createClass(SaitoProfile, [{
    key: "remove",
    value: function remove() {
      var myqs = "#saito-profile".concat(this.ordinal);
      if (document.querySelector(myqs)) {
        document.querySelector(myqs).remove();
      }
    }
  }, {
    key: "reset",
    value: function reset(publicKey) {
      var active_tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tabs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      //Make sure you remove it first!
      this.remove();
      if (!this.active_tab || !tabs.includes(this.active_tab)) {
        this.active_tab = active_tab;
      }
      this.resetMenuTabs(tabs);
      this.publicKey = publicKey;
      delete this.description;
      delete this.name;
      delete this.mask_key;
      this.ordinal = 0;
    }

    // Just rerender tabs ...
  }, {
    key: "render",
    value: function render() {
      if (this.ordinal == 0) {
        var max = 0;
        Array.from(document.querySelectorAll('.saito-profile')).forEach(function (ov) {
          var temp = parseInt(ov.id.replace('saito-profile', ''));
          if (temp > max) {
            max = temp;
          }
        });
        this.ordinal = max + 1;
      }
      var myqs = "#saito-profile".concat(this.ordinal);
      var content = SaitoProfileTemplate(this.app, this.mod, this);
      console.log('Render -- ' + myqs);
      if (document.querySelector(myqs)) {
        this.app.browser.replaceElementBySelector(content, myqs);
      } else if (this.container) {
        this.app.browser.prependElementToSelector(content, this.container);
      } else {
        this.app.browser.addElementToDom(content);
      }

      // send an event to profile mod
      this.app.connection.emit('profile-fetch-content-and-update-dom', this.publicKey);
      this.renderMenuTabs();
    }
  }, {
    key: "resetMenuTabs",
    value: function resetMenuTabs(tabs) {
      this.menu = {};
      var _iterator = _createForOfIteratorHelper(tabs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          this.menu[t] = [];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "renderMenuTabs",
    value: function renderMenuTabs() {
      var menu = document.querySelector("#saito-profile".concat(this.ordinal, " .saito-profile-menu"));
      if (menu) {
        menu.innerHTML = '';
        if (Object.keys(this.menu).length > 0) {
          for (var i in this.menu) {
            var class1 = i == this.active_tab ? ' active' : '';
            var class2 = this.menu[i].length > 0 ? '' : 'hidden';
            var html = "<div class=\"saito-profile-tab".concat(class1, "\" data-id=\"").concat(i, "\">\n                  ").concat(i, "\n                  <span class=\"").concat(class2, "\"> (").concat(this.menu[i].length, ")</span>\n                </div>");
            this.app.browser.addElementToSelector(html, "#saito-profile".concat(this.ordinal, " .saito-profile-menu"));
          }
        }
      }
      this.renderTab();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      if (this.tab_container) {
        document.querySelectorAll("#saito-profile".concat(this.ordinal, " .saito-profile-tab")).forEach(function (el) {
          el.onclick = function (e) {
            if (_this2.active_tab != e.currentTarget.dataset.id) {
              _this2.active_tab = e.currentTarget.dataset.id;
              _this2.renderMenuTabs();
            }
          };
        });
      }
      if (document.querySelector("#saito-profile".concat(this.ordinal, " #saito-banner-edit"))) {
        document.querySelector("#saito-profile".concat(this.ordinal, " #saito-banner-edit")).onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this2.app.connection.emit('profile-edit-banner', _this2.publicKey);
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      if (document.querySelector("#saito-profile".concat(this.ordinal, " .saito-profile-description.can-edit"))) {
        document.querySelector("#saito-profile".concat(this.ordinal, " .saito-profile-description.can-edit")).onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this2.app.connection.emit('profile-edit-description', _this2.publicKey);
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
      if (document.querySelector("#saito-profile".concat(this.ordinal, " #saito-profile-help"))) {
        document.querySelector("#saito-profile".concat(this.ordinal, " #saito-profile-help")).onclick = function (e) {
          var overlay = new SaitoOverlay(_this2.app, _this2.mod);
          var html = "<div class=\"saito-modal\">\n                <div class=\"saito-modal-title\">Profile Editing</div>\n                <div class=\"saito-profile-note\">You have the private key for this profile in your keychain.</div> \n                <div class=\"saito-profile-note\">You can edit it by opening importing that private key in a private browser \n                  directed to saito.io/profile</div>\n                </div>\n              </div>";
          overlay.show(html, function () {
            var localKey = _this2.app.keychain.returnKey(_this2.publicKey, true);
            if (localKey) {
              if (localKey !== null && localKey !== void 0 && localKey.privateKey) {
                var obj = {
                  publicKey: localKey.publicKey,
                  privateKey: localKey.privateKey
                };
                var base64obj = _this2.app.crypto.stringToBase64(JSON.stringify(obj));
                var link = window.location.origin + '/profile?load_key=' + base64obj;
                navigator.clipboard.writeText(link);
                siteMessage('Private URL copied', 5000);
              }
            }
          });
        };
      }
    }
  }, {
    key: "renderTab",
    value: function renderTab() {
      if (this.tab_container) {
        if (document.querySelector(this.tab_container)) {
          document.querySelector(this.tab_container).innerHTML = '';
        }
        if (this.active_tab && this.menu[this.active_tab]) {
          var _iterator2 = _createForOfIteratorHelper(this.menu[this.active_tab]),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var p = _step2.value;
              p.render();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    }
  }]);
}();
module.exports = SaitoProfile;